//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"Direction",1,"Direction",0],[0,"DirectionView",1,"View",0],[0,"Method",1,0],[0,"PartOccurrence",1,"Assemblies.Component",0],[0,"SecondaryCalloutActive",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.DimensionMeasurementBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.DimensionMeasurementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.DimensionMeasurementBuilder.MeasurementMethod = Object.freeze({
    "Inferred" : "Inferred", "Horizontal" : "Horizontal", "Vertical" : "Vertical", "PointToPoint" : "PointToPoint", "Perpendicular" : "Perpendicular", "Cylindrical" : "Cylindrical", "Angular" : "Angular", "Radial" : "Radial", "Diametral" : "Diametral", "HoleCallout" : "HoleCallout"});

export default SPLM;